import { useEffect, useLayoutEffect, useMemo, useState } from 'react';

const SCROLLS = /(auto|scroll|overlay)/;

// Nearest ancestor that scrolls vertically, or null for the window.
function findScrollParent(el) {
    for (let node = el?.parentElement; node && node !== document.body; node = node.parentElement) {
        if (SCROLLS.test(getComputedStyle(node).overflowY)) return node;
    }
    return null;
}

// antd `sticky` settings that keep a long table's horizontal scrollbar pinned
// to the bottom of the visible area while the table's own bar is out of view.
//
// The pages scroll inside an element (html and body are overflow: hidden), and
// antd only follows the container it is given, so the table looks up its own.
// antd re-checks when that container scrolls, not when rows expand or the data
// changes, so a scroll event is sent after each change in `deps`.
export function useStickyScroll(anchorRef, ...deps) {
    const [container, setContainer] = useState(null);

    useLayoutEffect(() => {
        setContainer(findScrollParent(anchorRef.current));
    }, [anchorRef]);

    useEffect(() => {
        const target = container || window;
        const id = requestAnimationFrame(() => target.dispatchEvent(new Event('scroll')));
        return () => cancelAnimationFrame(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [container, ...deps]);

    return useMemo(
        () => ({ offsetHeader: 0, offsetScroll: 0, getContainer: () => container || window }),
        [container],
    );
}
